import { render } from "./ObrasPage.vue?vue&type=template&id=4313ad4f&scoped=true"
import script from "./ObrasPage.vue?vue&type=script&lang=js"
export * from "./ObrasPage.vue?vue&type=script&lang=js"

import "./ObrasPage.vue?vue&type=style&index=0&id=4313ad4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4313ad4f"]])

export default __exports__